import { RQAPICallWithData } from 'store/APIClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'store/hooks';
import { Alert } from '../models';

const deleteAlert = async (alertId: number): Promise<{ message: string }> => {
    const response = await RQAPICallWithData({
        endpoint: `alert/${alertId}`,
        method: 'DELETE',
    });
    return response.content;
};

/**
 * RQ Mutation to delete the related alert. We need the source and the sourceId here
 * to write the new value in the cache.
 * @param {string} source - The source model that carries the alert to be deleted
 * @param {string | number} sourceId - The source key that points to the model.
 * @param {number} alertId - The id of the alert to delete
 */
export const useDeleteAlert = (
    source: string,
    sourceId: string | number,
    alertId: number,
) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: () => deleteAlert(alertId),

        onSuccess: ({ message }) => {
            queryClient.setQueryData(
                [source, sourceId, 'alerts', 'owned'],
                (oldAlerts: Array<Alert>) =>
                    oldAlerts.filter((oldAlert) => oldAlert.id !== alertId),
            );
            dispatch.vision.notifyUser({
                message,
                snackType: 'success',
            });
        },
        meta: { useGlobalOnError: true },
    });
};
